import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { installLocalModelFetch } from "@/lib/desktopLlm";
import "./styles.css";

// §14.5.1 In the desktop shell, divert the AI terminal's calls to the user's own model runner
// through the main process (no CORS there). A no-op everywhere else, so it is unconditional —
// and it runs before the first render so no component can race it with an early request.
installLocalModelFetch();

const container = document.getElementById("root");
if (!container)
  throw new Error('Root container "#root" is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
